<template>
    <div id="step-five-form" class="step-form">
        <p class="form-subheading" v-if="locations.length > 0">
            Added locations
            <span class="text-muted">({{locations.length}})</span>
        </p>
        <div id="locations-container" class="added_location">
            <LocationCard
                class="card"
                v-for="(location, index) in locations"
                :location="location"
                :index="index"
                :key="'location-'+index"
            />
        </div>
        <form @submit.prevent v-if="addMoreLocations || locations.length == 0">
            <!--<p>Add any streets, roads or parking lots you'll be using. Once you've added a location, you can modify it in the list below.</p>-->
            <p>Please add any streets, roads or parking lots you'll be using for filming and/or parking activity.  Once you've added a location, you can modify it in the list below.
            <div class="card pending-location">
                <div class="card-header">Add a location</div>
                <div class="card-body">
                    <p>Would you like to add an on-street location or a parking lot?</p>
                    <div class="form-row mb-3">
                        <RadioInput
                            inputId="locationType"
                            v-model="type"
                            :isRequired="false"
                            :optionalFlag="false"
                            :options="[{text:'On street/road',value:'street'},{text:'Parking lot',value:'lot'}]"
                        />
                    </div>
                    <fieldset class="pending-location" v-show="type == 'street'">
                        <div class="form-row" v-focus>
                            <TypeaheadInput
                                inputId="road"
                                v-model="street.StreetRoad"
                                labelText="Street name"
                                :options="roadList"
                                :wrapperClasses="['col-md-10']"
                                :isRequired="type == 'street'"
                                @optionSelected="getIntersections"
                            />
                        </div>
                        <div class="form-row">
                            <TypeaheadInput
                                inputId="Intersection_From"
                                v-model="street.Intersection_From"
                                labelText="From"
                                helpText="First crossroad"
                                :options="intersectionList"
                                :wrapperClasses="['col-md-10']"
                                :isRequired="type == 'street'"
                            />
                        </div>
                        <div class="form-row">
                            <TypeaheadInput
                                inputId="Intersection_To"
                                v-model="street.Intersection_To"
                                labelText="To"
                                helpText="Second crossroad"
                                :options="intersectionList"
                                :wrapperClasses="['col-md-10']"
                                :isRequired="type == 'street'"
                            />
                        </div>
                        <label class="form-label">Side of road</label>
                        <div class="form-row mb-3">
                            <RadioInput
                                inputId="street.StreetRoadSide"
                                v-model="street.StreetRoadSide"
                                name="streetRoadSide"
                                :options="[{text:'One',value:'O'},{text:'Both',value:'B'}]"
                                :isRequired="type == 'street'"
                                :inline="true"
                            />
                        </div>
                        <label class="form-label">Will you be parking overnight?</label>
                        <div class="form-row mb-3">
                            <RadioInput
                                inputId="OverNight"
                                v-model="street.OverNight"
                                name="Overnight"
                                :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                                :isRequired="type == 'street'"
                            />
                        </div>
                        <label class="form-label">Start date and time</label>
                        <DateTimeInput
                            inputId="StreetRoadStartDate"
                            v-model="street.StreetRoadStartDate"
                            :srOnly="true"
                            :defaultTime="{hour:7,minute:0}"
                            :isRequired="type == 'street'"
                        />
                        <label class="form-label">End date and time</label>
                        <DateTimeInput
                            inputId="StreetRoadEndDate"
                            v-model="street.StreetRoadEndDate"
                            :srOnly="true"
                            :defaultTime="{hour:23,minute:0}"
							:startDate="street.StreetRoadStartDate"
                            :validation="[{type:'before',value: street.StreetRoadStartDate, msg: 'Your end date can\'t be before your start date.'}]"
                            :isRequired="type == 'street'"
                        />
                    </fieldset>
                    <fieldset class="pending-location" v-show="type == 'lot'">
                        <div class="form-row" v-focus>
                            <TextInput
                                inputId="Location"
                                v-model="lot.Location"
                                labelText="Lot address"
                                helpText="Example: 300 City Centre Dr."
                                :isRequired="type == 'lot'"
                            />
                        </div>
                        <div class="form-row">
                            <NumberInput
                                inputId="NumOfSpaces"
                                v-model="lot.NumOfSpaces"
                                labelText="Number of spaces needed"
                                :isRequired="type == 'lot'"
                            />
                        </div>

                        <label class="form-label">Is this a privately owned lot?</label>
                        <div class="form-row mb-3">
                            <RadioInput
                                inputId="lot.Private"
                                v-model="lot.Private"
                                name="Private"
                                :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                                :isRequired="type == 'lot'"
                            />
                        </div>

                        <label class="form-label">Will you be parking overnight?</label>
                        <div class="form-row mb-3">
                            <RadioInput
                                inputId="OverNight"
                                v-model="lot.OverNight"
                                name="Overnight"
                                :options="[{text:'Yes',value:'Y'},{text:'No',value:'N'}]"
                                :isRequired="type == 'lot'"
                            />
                        </div>
                        <label class="form-label">Start date and time</label>
                        <DateTimeInput
                            inputId="LocationStartDate"
                            v-model="lot.LocationStartDate"
                            :srOnly="true"
                            :defaultTime="{hour:7,minute:0}"
                            :isRequired="type == 'lot'"
                        />
                        <label class="form-label">End date and time</label>
                        <DateTimeInput
                            inputId="LocationEndDate"
                            v-model="lot.LocationEndDate"
							:startDate="lot.LocationStartDate"
                            :srOnly="true"
                            :defaultTime="{hour:23,minute:0}"
                            :validation="[{type:'before',value: lot.LocationStartDate, msg: 'Your end date can\'t be before your start date.'}]"
                            :isRequired="type == 'lot'"
                        />
                    </fieldset>
                </div>
                <div
                    :class="['card__utility-bar card-footer', locations.length == 0 ? 'justify-content-start' : null]"
                >
                    <div
                        v-show="locations.length == 0"
                    >Pick a location type to add a location to your list.</div>
                    <button
                        class="btn-mobile btn btn-success no-wrap"
                        @click="addLocation(type)"
                        v-if="type"
                    >&plus; Add to list</button>
                    <div class="ml-3" v-if="confirmCancelLocation">
                        Are you sure?
                        <button
                            class="btn-confirm"
                            @click="confirmCancelLocation = false; addMoreLocations = false; type = '';"
                        >Yes</button> /
                        <button class="btn-confirm" @click="confirmCancelLocation = false;">No</button>
                    </div>
                    <button
                        class="btn btn-outline-danger"
                        @click="confirmCancelLocation = true"
                        v-show="!confirmCancelLocation && type"
                    >Cancel</button>
                </div>
            </div>
        </form>
        <div
            class="alert alert-danger mt-3"
            v-if="_errorsExist && submitted"
        >Please make sure you've filled all the fields out correctly.</div>

        <div class="d-flex justify-content-end align-items-right mt-3">
            <div v-if="confirmLocation">
                What location type?
                <button
                    class="btn-confirm"
                    @click="type='street'; confirmLocation = false; addMoreLocations = true;"
                >On street</button> /
                <button
                    class="btn-confirm"
                    @click="type = 'lot'; confirmLocation = false; addMoreLocations = true;"
                >Parking lot</button> /
                <button class="btn-confirm text-danger" @click="confirmLocation = false">Cancel</button>
            </div>
            <button
                class="btn-mobile btn btn-secondary mt-3 text-nowrap mr-3"
                @click="confirmLocation = true"
                v-show="oneLocationAdded && !confirmLocation"
            >Add another location</button>
            <div
                class="form-text text-danger mr-3"
                v-show="nextHover && type !== ''"
            >Click 'Add to list' to save the information you've entered before proceeding or click 'Cancel'.</div>
        </div>

        <div  v-if="savedAppValidationList.length > 0">
            <div class="alert alert-danger mt-3" v-if="!isStep5Validated">
                Please click Edit to update information in this section.
            </div>
        </div>

        <div class="d-flex justify-content-begin align-items-center mt-3">
            

            <button
                id="previousStep"
                class="mt-3 mr-3 btn btn-secondary"
                @click="previousStep"
            >Previous</button>
            <button
                id="nextStep"
                :class="['btn btn-primary mr-3', type !== '' || !isStep5Validated ? 'disabled' : null]"
                @click="nextStep"
                @mouseover.self="nextHover = true"
                @mouseout.self="nextHover = false"
            >Next</button>


            
        </div>
    </div>
</template>

<script>
//Try saying add another when theres one in the list.
import RadioInput from "@/components/inputs/RadioInput.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import NumberInput from "@/components/inputs/NumberInput.vue";
import TypeaheadInput from "@/components/inputs/TypeaheadInput.vue";
import DateTimeInput from "@/components/inputs/DateTimeInput.vue";
import LocationCard from "@/components/LocationCard.vue";
import moment from 'moment';

export default {
    name: "StepFiveForm",
    components: {
        RadioInput,
        TextInput,
        NumberInput,
        TypeaheadInput,
        DateTimeInput,
        LocationCard
    },
    data: function() {
        return {
            confirmLocation: false,
            street: {
                StreetRoad: "",
                Intersection_From: "",
                Intersection_To: "",
                StreetRoadStartDate: "",
                StreetRoadEndDate: "",
                StreetRoadSide: "",
                StreetRoadUseType: "parking",
                OverNight: ""
            },
            lot: {
                Location: "",
                NumOfSpaces: 0,
                LocationStartDate: "",
                LocationEndDate: "",
                Private: "",
                OverNight: ""
            },
            type: "",
            step: 5,
            submitted: false,
            nextHover: false,
            prevQuery: "",
            addMoreLocations: false,
            confirmCancelLocation: false,
            isStep5Validated: true,
        };
    },
    computed: {
        oneLocationAdded() {
            return this.locations.length > 0;
        },
        locations() {
            return this.$store.getters.getParkingLocations;
        },
        roadList() {
            return this.$store.getters.getRoadList;
        },
        intersectionList() {
            return this.$store.getters.getIntersectionList;
        },
        savedAppValidationList() {
            return this.$store.getters.savedAppValidationList;
        },
        /*
        Step5Validation()
        {
            var valObj = this.$store.getters.savedAppValidationList.filter(x => x.step == 5);
            if(valObj.length > 0)
            {
                this.isStep5Validated = false;
            }  
            else
            {
                this.isStep5Validated = true;
            }

            // var valObj = this.$store.getters.savedAppValidationList.filter(function(elem){
            //     if(elem.step == "5") 
            //     {
            //         this.isStep5Validated = false;
            //         return false;
            //     }
            //     else 
            //     {
            //         this.isStep5Validated = true;
            //         return true;
            //     }
            // });
        }*/
    },
    methods: {
        getIntersections(road) {
            // this.street.Intersection_From = "";
            // this.street.Intersection_To = "";
            this.$store.dispatch("GET_INTERSECTION_LIST", road);
        },
        resetLocationData() {
            const template = {
                street: {
                    StreetRoad: "",
                    Intersection_From: "",
                    Intersection_To: "",
                    StreetRoadStartDate: "",
                    StreetRoadEndDate: "",
                    StreetRoadSide: "",
                    StreetRoadUseType: "parking",
                    OverNight: ""
                },
                lot: {
                    Location: "",
                    NumOfSpaces: 0,
                    LocationStartDate: "",
                    LocationEndDate: "",
                    Private: "",
                    OverNight: ""
                }
            };
            this.street = template.street;
            this.lot = template.lot;
            this.submitted = false;
            this.type = "";
        },
        addLocation(locationType) {
            this.submitted = true;
            this.addMoreLocations = false;
            this.$el.focus();
            if (!this._errorsExist()) {
                this.$store
                    .dispatch(
                        "ADD_LOCATION",
                        Object.assign(
                            { type: locationType },
                            this[locationType]
                        )
                    )
                    .then(() => {
                        this.resetLocationData();
                    });
            }
        },
        nextStep() {
            

            if (this.type !== "") return;
            if(this.isStep5Validated)
            {
                this.$store.dispatch("COMPLETE_STEP", {
                step: this.step,
                complete: true
            });
            }
            
        },
        previousStep() { 
                this.$store.dispatch('SET_STEP', this.step - 1);        
        },
    },
    mounted() {
        var valObj = this.$store.getters.savedAppValidationList.filter(x => x.step == 5);
            if(valObj.length > 0)
            {
                this.isStep5Validated = false;
            }  
            else
            {
                this.isStep5Validated = true;
            }
        //***** NEW Implementation for step 5 validation for saved app data */
        /*
        var valObj = this.$store.getters.getParkingLocations
        var currentDate = moment().format("YYYY-MM-DD");
        //var valObj = data.specs.filter(function(elem){
        //                if(elem.StreetRoadStartDate == "Power") return elem.Value;
        //            });
        for(var i=0; i< valObj.length; i++)
        {
            if(valObj[i].type =="street")
            {
                var streetRoadStartDate = moment(valObj[i].StreetRoadStartDate).format("YYYY-MM-DD");
                var streetRoadEndDate = moment(valObj[i].StreetRoadEndDate).format("YYYY-MM-DD");		
                if (moment(streetRoadStartDate).isBefore(currentDate))
                {
                    this.isStep5Validated = false;
                }
                else
                {
                    this.isStep5Validated = true;
                }
                if (moment(streetRoadEndDate).isBefore(currentDate))
                {
                    this.isStep5Validated = false
                }
                else
                {
                    this.isStep5Validated = true;
                }
            }
            else if(valObj[i].type =="lot")
            {
                var parkingLocationStartDate = moment(valObj[i].LocationStartDate).format("YYYY-MM-DD");
                var parkingLocationEndDate = moment(valObj[i].LocationEndDate).format("YYYY-MM-DD");	
                if (moment(parkingLocationStartDate).isBefore(currentDate))
                {

                }
                if (moment(parkingLocationEndDate).isBefore(currentDate))
                {

                }
            }
        }
        */
        /*****END of New implementation ****************/
    },
    watch: {
        locations(newLocations) { //, oldLocations
            //let updatedLocations = Object.assign({}, newLocations)
            //console.log(`New locations: ${JSON.parse(updatedLocations)} `);

            var currentDate = moment().format("YYYY-MM-DD");
            var isStreetRoadStartDateValid = true;
            var isStreetRoadEndDateValid = true;
            var isParkingLocationStartDate = true;
            var isParkingLocationEndDate = true;
            //Object.keys(updatedLocations).forEach(item => {
            newLocations.forEach((item) => {
                switch (item.type) {
                    case "street":{
                        var streetRoadStartDate = moment(item.StreetRoadStartDate).format("YYYY-MM-DD");
                        var streetRoadEndDate = moment(item.StreetRoadEndDate).format("YYYY-MM-DD");
                        if (moment(streetRoadStartDate).isBefore(currentDate))  //Or use: isSameOrBefore
                        {
                            isStreetRoadStartDateValid = false;
                            break; //TODO:Should we break out the loop right away when one item is not valid.
                        }                 

                        if (moment(streetRoadEndDate).isBefore(currentDate))
                        {
                            isStreetRoadEndDateValid = false;
                            break;
                        }                 

                            
                        break;
                    }    
                    case "lot": {
                        var parkingLocationStartDate = moment(item.LocationStartDate).format("YYYY-MM-DD");
                        var parkingLocationEndDate = moment(item.LocationEndDate).format("YYYY-MM-DD");
                        if (moment(parkingLocationStartDate).isBefore(currentDate))
                        {
                            isParkingLocationStartDate = false;
                            break;
                        }                 

                        if (moment(parkingLocationEndDate).isBefore(currentDate))
                        {
                            isParkingLocationEndDate = false;
                            break;
                        }                 

                        break;
                    }
                }
            });

            //check for "newLocation" date/time validation and assign:
            if (!isStreetRoadStartDateValid || !isStreetRoadEndDateValid || !isParkingLocationStartDate || !isParkingLocationEndDate)
            {
                this.isStep5Validated = false;
            }
            else
            {
                this.isStep5Validated = true;
            }
            //this.isStep5Validated = true;
        }
    }
};
</script>
